import React from 'react'

import CustomField from '../../CustomField'

import useStyles from './styles'

const CustomFields = ({
  initialData,
  objectType,
  storeFields,
  saving,
  changed,
  setChanged,
  triggerSave,
  setTriggerSave,
  saveDelete,
  search = ''
}) => {
  const [data, setData] = React.useState(initialData ?? [])
  const [availableDataKeys, setAvailableDataKeys] = React.useState({})

  const availableData = React.useMemo(
    () =>
      data.filter(d => {
        const notArchived = [undefined, null].includes(d.archived_at)
        const trimmedSearch = search.trim().toLocaleLowerCase()
        if (trimmedSearch.length === 0) {
          return notArchived
        }

        const searchableData = [d.title ?? '', d.description ?? '']
        const searchMatches = searchableData.some(val =>
          val.toLocaleLowerCase().includes(trimmedSearch)
        )

        return notArchived && searchMatches
      }),
    [data, search]
  )

  const classes = useStyles()

  React.useEffect(() => {
    setData(initialData ?? [])
  }, [initialData])

  React.useEffect(() => {
    setAvailableDataKeys(
      data
        .filter(d => [undefined, null].includes(d.archived_at))
        .reduce((a, v) => ({ ...a, [v.id]: false }), {}) ?? {}
    )
  }, [data])

  React.useEffect(() => {
    if (
      triggerSave[objectType] &&
      Object.values(availableDataKeys).every(value => value === true)
    ) {
      storeFields(objectType, data)
      setTriggerSave(old => ({ ...old, [objectType]: false }))
      setAvailableDataKeys(
        data
          .filter(d => [undefined, null].includes(d.archived_at))
          .reduce((a, v) => ({ ...a, [v.id]: false }), {}) ?? {}
      )
    }
  }, [
    triggerSave,
    objectType,
    setTriggerSave,
    storeFields,
    availableData,
    availableDataKeys,
    data
  ])

  return (
    <>
      {availableData.length > 0 ? (
        <div className={classes.root}>
          {availableData.map(field => (
            <CustomField key={field.id} field={field} />
          ))}
        </div>
      ) : (
        <label className={classes.greyText}>
          {search.trim().length > 0
            ? 'No custom fields match this search'
            : 'No custom fields for this type'}
        </label>
      )}
    </>
  )
}

export default CustomFields
